/**
 * Supported Question types
 */
export enum QuestionTypes {
  /**
   * Used for single select from multiple choice
   */
  singleSelect = 'singleSelect',
  /**
  * Used for multi select from multiple choice
  */
  multiSelect = 'multiSelect',
  /**
   * Used to pick a date
   */
  datePicker = 'datePicker',
  /**
   * Used to fill string
   */
  text = 'text',
  /**
   * Used for like and dislike
   */
  likeDislike = 'likeDislike',
  /**
   * Used for text response up to 100 chars.
   */
  openEnded = 'openEnded',
}

export enum AppSurveyStatuses {
  active = 'active',
  inactive = 'inactive',
}

export enum UserSurveyStatuses {
  draft = 'draft',
  submitted = 'submitted',
}
